export const ShowingTypes = {
  HIGH_AVAILABILITY: 'high_availability',
  OPEN_HOUSE: 'open_house',
  RESTRICTED: 'restricted',
  SELF_SHOWING: 'self_showing',
  PUBLISH_LISTING: 'publish_listing',
};

export const ShowingTypesDisplay = {
  [ShowingTypes.HIGH_AVAILABILITY]: 'High Availability',
  [ShowingTypes.OPEN_HOUSE]: 'Open House',
  [ShowingTypes.RESTRICTED]: 'Restricted',
  [ShowingTypes.SELF_SHOWING]: 'Self Showing',
  [ShowingTypes.PUBLISH_LISTING]: 'Publish Listing',
};
